var _rect, _rect2, _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLastMileLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.3176,
    y: 53.8242,
    width: 36.4509,
    height: 3.21205,
    transform: "rotate(-12.0752 10.3176 53.8242)",
    fill: "#3A3636"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8044,
    y: 38.5078,
    width: 17.7103,
    height: 3.21205,
    transform: "rotate(21.0673 31.8044 38.5078)",
    fill: "#3A3636"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.71612,
    cy: 55.8535,
    rx: 6.71612,
    ry: 4.14647,
    fill: "#23C1D7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.0494,
    cy: 47.5644,
    rx: 6.71612,
    ry: 4.14647,
    fill: "#23C1D7"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.2659,
    cy: 39.0293,
    rx: 6.71612,
    ry: 4.14647,
    fill: "#31C952"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9218 38.8463C24.4918 36.4669 16.9272 29.5389 14.109 20.8619C12.3785 16.5048 11.4391 6.52993 21.5253 1.48688C25.8514 -0.583496 35.9128 -2.09147 41.5492 8.43962C43.1869 11.437 44.7381 19.6382 37.841 28.4635C35.8634 31.1519 31.1108 36.9922 27.9218 38.8463ZM27.9454 20.469C31.2733 20.469 33.9711 17.7712 33.9711 14.4433C33.9711 11.1154 31.2733 8.41758 27.9454 8.41758C24.6175 8.41758 21.9197 11.1154 21.9197 14.4433C21.9197 17.7712 24.6175 20.469 27.9454 20.469Z",
    fill: "#FD4C50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1401 54.9194L43.4503 48.2617",
    stroke: "black",
    strokeDasharray: "8 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.34 41.2544L44.3266 45.1668",
    stroke: "black",
    strokeDasharray: "8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastMileLogo);
export default __webpack_public_path__ + "static/media/lastMileLogo.ec261fe3c807698dd2616f8c93aad008.svg";
export { ForwardRef as ReactComponent };